export enum SentryEnv {
	Local = 'local',
	Dev = 'dev',
	Demo = 'demo',
	Stage = 'stage',
	Prod = 'prod'
}
